import React from "react";
import {Button, Spinner} from "reactstrap";
import ModalComponent from "../../atoms/Modal";

interface AssignmentModalProps {
  show: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  message: string;
  onConfirm: () => void;
  isConfirming?: boolean;
  confirmText?: string;
  cancelText?: string;
}

const AssignmentModal = ({
  show,
  setOpen,
  title,
  message,
  onConfirm,
  isConfirming = false,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
}: AssignmentModalProps) => {
  return (
    <ModalComponent
      show={show}
      setOpen={setOpen}
      title={title}
      size="md"
      centered
    >
      <div className="text-center p-3">

        <div className="avatar-md mx-auto mb-4">
          <div className="avatar-title bg-soft-primary text-light rounded-circle">
            <i className="bx bx-user-check fs-1"></i>
          </div>
        </div>

        <h4>{title}</h4>

        <p className="text-muted fs-15 mb-4">
          {message}
        </p>


        <div className="d-flex gap-2 justify-content-end mt-4">
          <Button
            color="light"
            className="btn-light waves-effect"
            onClick={() => setOpen(false)}
            disabled={isConfirming}
            style={{ minWidth: "120px" }}
          >
            {cancelText}
          </Button>
          <Button color="primary"
                  onClick={onConfirm}
                  disabled={isConfirming}>
            {isConfirming ? (
              <> <Spinner size="sm" className="me-2" /> Guardando...</>
            ) : (confirmText)}
          </Button>
        </div>
      </div>
    </ModalComponent>
  );
};

export default AssignmentModal;
